__webpack_require__.p = "https://app.stg.pic.astrazeneca.com/";